/**
* 头部菜单
*/
<template>
  <div>
    <el-menu class="el-menu-demo" mode="horizontal" background-color="#334157" text-color="#fff" active-text-color="#fff">
      <el-button class="buttonimg">
        <img class="showimg" :src="collapsed?imgsq:imgshow" @click="toggle(collapsed)">
      </el-button>
      <el-submenu index="2" class="submenu">
        <template slot="title">{{user.realname}}</template>
        <el-menu-item @click="passwdVisible = true">修改密码</el-menu-item>
        <!-- <el-menu-item @click="content()" index="2-2">个人中心</el-menu-item> -->
        <el-menu-item @click="exit()" index="2-3">退出</el-menu-item>
      </el-submenu>
    </el-menu>
    <el-dialog title="修改密码" :visible.sync="passwdVisible" width="360px" :close-on-click-modal="false">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
        <el-form-item label="新 密 码" prop="newpasswd">
          <el-input v-model="ruleForm.newpasswd" autocomplete="off" type="password" style="width: 200px;margin-left:6px;"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="repasswd">
          <el-input v-model="ruleForm.repasswd" autocomplete="off" type="password" style="width: 200px;"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="passwdVisible = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>

</template>
<script>
import { loginout,editPasswd } from '../api/userMG'
export default {
  name: 'navcon',
  data() {
    var validator1 = (rule, val, callback) =>{
      if(val == ''){callback(new Error('请输入密码'))}
      if(val.length < 6 || val.length > 12){callback(new Error('密码长度位6-12位'))}
      callback();
    }
    var validator2 = (rule, val, callback) =>{
      if(val == ''){callback(new Error('请输入确认密码'))}
      if(val !== this.ruleForm.newpasswd){callback(new Error('输入的密码不一致'))}
      callback();
    }
    return {
      collapsed: true,
      passwdVisible: false,
      imgshow: require('../assets/img/show.png'),
      imgsq: require('../assets/img/sq.png'),
      user: {},
      ruleForm: {
        newpasswd: '',
        repasswd: ''
      },
      rules: {
        newpasswd: [{ validator: validator1, trigger: 'blur' }],
        repasswd: [{ validator: validator2, trigger: 'blur' }]
      }
    }
  },
  // 创建完毕状态(里面是操作)
  created() {
    this.user = JSON.parse(localStorage.getItem('userdata'))
  },
  methods: {
    // 退出登录
    exit() {
      this.$confirm('退出登录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          /* setTimeout(() => {
            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '已退出登录!'
            })
          }, 1000) */
           loginout()
             .then(res => {
               if (res.code == 0) {
                 //如果请求成功就让他2秒跳转路由
                 setTimeout(() => {
                   this.$store.commit('logout', 'false')
                   this.$router.push({ path: '/login' })
                   this.$message({
                     type: 'success',
                     message: '已退出登录!'
                   })
                 }, 1000)
               } else {
                 this.$message.error(res.msg)
                 this.logining = false
                 return false
               }
             })
             .catch(err => {
               this.logining = false
               this.$message.error('退出失败，请稍后再试！')
             })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    // 切换显示
    toggle(showtype) {
      this.collapsed = !showtype
      this.$root.Bus.$emit('toggle', this.collapsed)
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          editPasswd(this.ruleForm).then(res => {
            if(res.code == 0){
              this.passwdVisible = false
              this.$message({
                type: 'success',
                message: res.msg
              })
            }else{
              this.$message.error(res.msg)
            }

          })
          .catch( err => {
            this.passwdVisible = false
            this.$message.error('退出失败，请稍后再试！')
          })
        }
      })
    }

  }
}
</script>
<style scoped>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
}
.submenu {
  float: right;
}
.buttonimg {
  height: 60px;
  background-color: transparent;
  border: none;
}
.showimg {
  width: 26px;
  height: 26px;
  position: absolute;
  top: 17px;
  left: 17px;
}
.showimg:active {
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/navcon.vue